<template>
  <v-card style="background-color: #f4f3f3" height="100vh">
    <div
      class="pa-10 uk-container uk-padding"
      style="overflow-y: auto; height: calc(100vh - 64px)"
    >
      <div class="pa-8 uk-container uk-padding ml-1">
        <div class="uk-timeline">
          <div class="uk-timeline-item">
            <div class="uk-timeline-icon">
              <span class="uk-badge">1</span>
            </div>
            <div class="uk-timeline-content">
              <div class="uk-card uk-card-default uk-margin-medium-bottom">
                <div class="uk-card-header">
                  <div class="uk-grid-small uk-flex-middle">
                    <div class="text-body-1 font-weight-bold">
                      {{ $t("migrationCreationCSV.step1") }}
                    </div>
                  </div>
                </div>
                <div class="uk-card-body">
                  <p class="px-0 my-4">
                    <download-csv
                      :data="usersEmail"
                      :labels="labels"
                      :fields="migrationConfigFields"
                      :file-name="`${csvName} - ${companyName}`"
                    >
                      <v-btn
                        color="background"
                        elevation="3"
                        class="primary--text mx-0"
                      >
                        <v-icon left>ph-download-simple</v-icon>
                        {{ $t("migrationCreationCSV.buttonDownload") }}
                      </v-btn>
                    </download-csv>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-timeline-item mt-6">
            <div class="uk-timeline-icon">
              <span class="uk-badge">2</span>
            </div>
            <div class="uk-timeline-content">
              <div class="uk-card uk-card-default uk-margin-medium-bottom">
                <div class="uk-card-header">
                  <div class="uk-grid-small uk-flex-middle">
                    <div class="text-body-1 font-weight-bold">
                      {{ $t("migrationCreationCSV.step2") }}
                    </div>
                  </div>
                </div>
                <div class="uk-card-body pt-4">
                  <MigrationAlertUpgradePlan />
                  <Alert
                    v-if="hasTrialPlans"
                    dense
                    color="warning"
                    class="mt-4"
                    :actionText="$t('action.seePlans')"
                    :actionIcon="''"
                    @action="sendToUpgradePlan"
                  >
                    {{ $t("migrationCreationCSV.trialAlert") }}
                  </Alert>

                  <Alert color="info" dense class="font-weight-bold">
                    <p>
                      {{ $t("migrationCreationCSV.instructionStep2Title") }}
                    </p>
                    <ul class="py-1">
                      <li>
                        {{
                          $t(
                            "migrationCreationCSV.instructionStep2RequiredFields"
                          )
                        }}
                      </li>
                      <li>
                        {{
                          $t(
                            "migrationCreationCSV.instructionStep2RemoveUnusedRows"
                          )
                        }}
                      </li>
                      <li>
                        {{
                          $t(
                            "migrationCreationCSV.instructionStep2SharedWithField"
                          )
                        }}
                      </li>
                      <li v-if="hasTrialPlans">
                        {{
                          $t(
                            "migrationCreationCSV.instructionStep2DateFieldTrial"
                          )
                        }}
                      </li>
                      <li v-else>
                        {{
                          $t("migrationCreationCSV.instructionStep2DateField")
                        }}
                      </li>
                    </ul>
                  </Alert>
                  <v-card class="transparent py-2 elevation-0" tile>
                    <table class="text-body-2">
                      <thead class="grey lighten-2 border-0">
                        <tr>
                          <th class="text-left pa-2">
                            {{ labels.source_email }}
                          </th>
                          <th class="text-left pa-2">
                            {{ labels.target_email }}
                          </th>
                          <!-- TODO: campos de drive -->
                          <!-- <th class="text-left pa-2">
                            {{ labels.target_drive_email }}
                          </th> -->
                          <th class="text-left pa-2">
                            {{ labels.shared_with }}
                          </th>
                          <th class="text-left pa-2">{{ labels.period }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-left pa-2 outlined">
                            {{ $t("migrationCreationCSV.exampleSourceEmail") }}
                          </td>
                          <td class="text-left pa-2 outlined">
                            {{ $t("migrationCreationCSV.exampleTargetEmail") }}
                          </td>
                          <!-- TODO: campos de drive-->
                          <!-- <td class="text-left pa-2 outlined">
                            {{
                              $t("migrationCreationCSV.exampleTargetDriveEmail")
                            }}
                          </td> -->
                          <td class="text-left pa-2 outlined">
                            {{ $t("migrationCreationCSV.exampleSharedWith") }}
                          </td>
                          <td class="text-left pa-2 outlined">
                            {{ $t("migrationCreationCSV.examplePeriod") }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-card>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-timeline-item mt-6">
            <div class="uk-timeline-icon">
              <span class="uk-badge">3</span>
            </div>
            <div class="uk-timeline-content">
              <div>
                <div class="uk-card-header">
                  <div class="uk-grid-small uk-flex-middle">
                    <div class="text-body-1 font-weight-bold">
                      {{ $t("migrationCreationCSV.step3") }}
                    </div>
                  </div>
                </div>
                <div class="uk-card-body pt-4">
                  <upload-csv
                    @content="validateImportedData"
                    @fileName="setImportedFileName"
                    @error="handleError"
                    :disabled="hasTaskRunning ?? true"
                    :tooltipMessage="
                      hasTaskRunning
                        ? $t('migrationHistory.migrationInProgress')
                        : null
                    "
                  />
                  <v-card-subtitle
                    class="px-0 mt-4 d-flex align-center"
                    v-if="importedFileName"
                  >
                    <v-icon
                      small
                      color="accent"
                      class="mr-2"
                      style="cursor: pointer"
                      @click="removeFile"
                    >
                      ph ph-trash-simple
                    </v-icon>
                    <span>{{ importedFileName }}</span>
                  </v-card-subtitle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-footer
        style="height: 70px; margin: auto"
        color="transparent"
        max-width="95vw"
        class="mt-8"
      >
        <v-btn
          text
          height="52"
          color="secondary"
          style="border: 2px solid grey !important"
          class="text-none text-body-1 font-weight-medium px-8"
          outlined
          @click="$emit('back')"
        >
          <v-icon right class="mr-4" size="22">ph-arrow-left</v-icon>
          {{ $t("common.back") }}
        </v-btn>
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-btn
                right
                height="52"
                color="accent"
                class="text-none text-body-1 font-weight-bold px-8"
                :disabled="!nextStep"
                :loading="loading"
                @click="$emit('advance')"
              >
                {{ $t("common.advance") }}
                <v-icon right class="ml-4" size="22">ph-arrow-right</v-icon>
              </v-btn>
            </span>
          </template>
          <span v-if="hasTaskRunning ?? true">
            {{ $t("migrationHistory.migrationInProgress") }}
          </span>
          <span v-if="hasErrorUpload">
            {{ $t("migrationCreationCSV.uploadTooltipError") }}
          </span>
          <span v-else-if="!nextStep && !hasErrorUpload">
            {{ $t("migrationCreationCSV.uploadTooltipEmpty") }}
          </span>
          <span v-else>
            {{ $t("migrationCreationCSV.uploadTooltipReady") }}</span
          >
        </v-tooltip>
      </v-footer>
    </div>
  </v-card>
</template>
<script>
import JsonCSV from "@/components/main/shared/download.vue";
import MigrationAlertUpgradePlan from "@/components/migration/MigrationAlertUpgradePlan.vue";
import { labels, migrationConfigFields } from "@/helpers/variables/migrations";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Upload from "./Upload.vue";

export default {
  name: "ImportMigrationCSV",
  components: {
    "download-csv": JsonCSV,
    "upload-csv": Upload,
    MigrationAlertUpgradePlan,
  },
  data() {
    return {
      migrationConfigFields,
      labels,
      importedFileName: "",
      nextStep: false,
      loading: false,
      hasErrorUpload: false,
      hasTaskRunning: true,
    };
  },
  computed: {
    ...mapGetters([
      "company",
      "users",
      "token",
      "hasIntegracaoPontoMais",
      "migrationsHistory",
      "hasTrialPlans",
    ]),
    csvName() {
      return this.$t("migrationCreationCSV.fileName");
    },
    companyName() {
      return this.company.name;
    },
    usersEmail() {
      return this.users.map((user) => {
        const row = {};
        migrationConfigFields.forEach((field) => {
          row[field] = field === "source_email" ? user.email || "" : "";
        });
        return row;
      });
    },
    snackbarConfig() {
      return { show: true };
    },
    migrationsAndCompany() {
      return {
        migrationsHistory: this.migrationsHistory,
        current_plan: this.company?.current_plan,
      };
    },
  },
  methods: {
    ...mapMutations(["setImportedCsvValidation", "setSnackBar"]),
    ...mapActions(["checkHasTaskRunningByCompany"]),

    sendToUpgradePlan() {
      this.$router.push({ name: "BillingUpgradePlan" });
    },

    validateImportedData(csvData) {
      if (!Array.isArray(csvData) || csvData.length === 0) {
        this.handleError("CSV vazio ou inválido");
        return;
      }
      this.loading = true;
      this.resetCsvData();

      const url = `${process.env.VUE_APP_API_BASE_URL}/migration/validate`;
      const config = {
        headers: { Authorization: this.token },
      };

      const dataToValidate = this.hasIntegracaoPontoMais
        ? csvData
        : [csvData[0]];

      this.$axios
        .post(url, dataToValidate, config)
        .then(({ data }) => {
          this.setImportedCsvValidation(data);
          this.nextStep = true;
          this.hasErrorUpload = false;

          this.snackbarConfig.message = this.$t(
            "migrationCreationCSV.snackbarUploadSuccess"
          );
          this.snackbarConfig.color = "success";
          this.setSnackBar(this.snackbarConfig);
        })
        .catch(({ response }) => {
          console.error("validateImportedData()", response);
          this.hasErrorUpload = true;
          if (response?.data?.code) {
            this.snackbarConfig.message = this.$t(
              `errorMessages.${response.data.code}`
            );
          } else {
            this.snackbarConfig.message = this.$t(
              "migrationCreationCSV.snackbarUploadError"
            );
          }
          this.snackbarConfig.color = "error";
          this.setSnackBar(this.snackbarConfig);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setImportedFileName(fileName) {
      this.importedFileName = fileName;
    },
    removeFile() {
      this.importedFileName = "";
      this.nextStep = false;
      this.loading = false;
      this.hasErrorUpload = false;
      this.setImportedCsvValidation([]);
    },
    resetCsvData() {
      this.setImportedCsvValidation([]);
      this.nextStep = false;
      this.hasErrorUpload = false;
    },
    handleError(err) {
      console.error("upload-csv handleError()", err);
      this.hasErrorUpload = true;
      this.nextStep = false;

      this.snackbarConfig.message = this.$t(
        "migrationCreationCSV.snackbarUploadError"
      );
      this.snackbarConfig.color = "error";
      this.setSnackBar(this.snackbarConfig);
    },
  },
  watch: {
    migrationsAndCompany: {
      immediate: true,
      async handler() {
        if (this.hasIntegracaoPontoMais) {
          this.hasTaskRunning = false;
          return;
        }
        this.hasTaskRunning = await this.checkHasTaskRunningByCompany();
      },
    },
  },
};
</script>
